module.exports = __webpack_public_path__ + "img/4.eb30a817.png";